import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatMessageUtilityClass(slot) {
  return generateUtilityClass('MuiChatMessage', slot);
}
export const chatMessageClasses = generateUtilityClasses('MuiChatMessage', ['root', 'avatar', 'authorLabel', 'content', 'bubble', 'meta', 'actions', 'group', 'groupAuthorName', 'groupTimestamp', 'inlineMetaSpacer', 'inlineMeta', 'dateDivider', 'dateDividerLine', 'dateDividerLabel', 'roleUser', 'roleAssistant', 'streaming', 'error', 'noAvatar']);
const slots = {
  root: ['root'],
  avatar: ['avatar'],
  authorLabel: ['authorLabel'],
  content: ['content'],
  bubble: ['bubble'],
  meta: ['meta'],
  actions: ['actions'],
  group: ['group'],
  groupAuthorName: ['groupAuthorName'],
  groupTimestamp: ['groupTimestamp'],
  inlineMetaSpacer: ['inlineMetaSpacer'],
  inlineMeta: ['inlineMeta'],
  dateDivider: ['dateDivider'],
  dateDividerLine: ['dateDividerLine'],
  dateDividerLabel: ['dateDividerLabel'],
  roleUser: ['roleUser'],
  roleAssistant: ['roleAssistant'],
  streaming: ['streaming'],
  error: ['error'],
  noAvatar: ['noAvatar']
};
export const useChatMessageUtilityClasses = classes => composeClasses(slots, getChatMessageUtilityClass, classes);